(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyFromDetailController', MedFrequencyFromDetailController);

    MedFrequencyFromDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MedFrequencyFrom', 'Medication', 'Corporation'];

    function MedFrequencyFromDetailController($scope, $rootScope, $stateParams, previousState, entity, MedFrequencyFrom, Medication, Corporation) {
        var vm = this;

        vm.medFrequencyFrom = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:medFrequencyFromUpdate', function(event, result) {
            vm.medFrequencyFrom = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
